module.exports = __webpack_public_path__ + "img/icon_manage.c8dc8329.svg";